<template>
    <div class="hello">
        <h1>{{ msg }}</h1>
        <ul>
            <router-link to="/list/1/circle">Circle</router-link>
            |
            <router-link to="/list/6/subject">Subject</router-link>
            |
            <router-link to="/user/186546">User</router-link>
            |
            <router-link to="/detail/18/article">Article</router-link>
            |
            <router-link to="/detail/2042/Video">Video</router-link>
        </ul>
    </div>
</template>
<script>
  export default {
    name: "HelloWorld",
    props: {
      msg: String
    }
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    #nav {
        display: block;
        padding: 30px;
        a {
            font-weight: bold;
            color: #2c3e50;
            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>
